import { render, staticRenderFns } from "./ImageSquareCard.vue?vue&type=template&id=55f49cd6&"
import script from "./ImageSquareCard.vue?vue&type=script&lang=js&"
export * from "./ImageSquareCard.vue?vue&type=script&lang=js&"
import style0 from "./ImageSquareCard.vue?vue&type=style&index=0&id=55f49cd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports